import React, { Component } from 'react'
import { Table, Tooltip, Modal, message, Collapse, Form, Select, DatePicker, Button, Radio, Input, Card } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all, get } from '../../services/restApi'
import { getTotal, createPassword } from '../../utils'
import PayrollNew from './payrollNew'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;
const ButtonGroup = Button.Group;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const MonthPicker = DatePicker.MonthPicker;

class Payroll extends Component {

    constructor (props) {
        super(props);

        this.state = {
            query: {},
            hotels: [],
            incomes: [],
            showModalPayrollDetails: false,
            NewIncomeVisible: false,
            newIncomeProps: {incomeType: 'payroll'},
            limit: 1000
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)  {
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
        } else {
            if (this.props.location.pathname === '/incomes/payroll/hotel')
                window.history.back()
        }

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.params.incomeType === 'trie')
            this.state = {...this.state, currentHotel: null};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Consulta los hoteles
        all('Hotel', {limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })
    }


    /**
    * Se llama antes del render()
    */
    componentWillMount () {
        this.props.dispatch({type:'income/filterSuccess', 
            payload: {
                incomes: [], 
                skip: this.state.limit, 
                total_items: 0
            }
        });

        this.firstLoad();
    }



    /**
    * Agrupamos: Cada registro por fecha de creación
    */
    groupByDate (array, count) {

        let incomesGrouped = _.groupBy(array, function (d) { return moment(d.requestedAt.iso).format('YYYY-MM-DD') });

        Object.keys(incomesGrouped).map((key, index) => {

            let item = {};
            item.requestedAt = {__type: 'Date', iso: key};
            item.isParent =  true;
            item.children =  incomesGrouped[key];
            item.objectId = createPassword();
            item.amount_expense_total = getTotal(incomesGrouped[key], 'amount_expense');

            this.state.incomes.push(item);

            if (index === Object.keys(incomesGrouped).length - 1) {

                setTimeout(function() {
                    this.props.dispatch({type: 'app/hideLoadingTable'})
                    this.props.dispatch({type:'income/querySuccess', 
                        payload: {
                            incomes: this.state.incomes, 
                            skip: this.state.limit, 
                            total_items: count
                        }
                    });
                }.bind(this), 1000);
            }
        });
    }


    /**
    * Consulta el reporte anterior para saber el saldo
    */
    getPreviousTotal () {
        this.props.form.validateFieldsAndScroll((errors, values) => {
            // Query
            let query = {chargedTo: this.props.params.incomeType};

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            if (values.custom_date) {
                query.startAt = {
                    $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).subtract(1, 'months').startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).subtract(1, 'months').endOf('month').format()).toISOString()},
                }
            } else {
                query.startAt = {
                    $gte: {__type: 'Date', iso: new Date(moment().subtract(1, 'months').startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment().subtract(1, 'months').endOf('month').format()).toISOString()},
                }
            }

            all('Payroll', {
                where: query,
                skip: 0, 
                limit: 1000, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {

                if (resp.results.length > 0) {

                    let previousTotal = getTotal(resp.results, 'total');
                    this.setState({ previousTotal: previousTotal });
                } else {
                    this.setState({ previousTotal: 0 });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        });
    }


    /**
    * Primera carga
    */
    firstLoad () {
        let query = {chargedTo: this.props.params.incomeType};
        query.startAt = {
            $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
            $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
        };

        if (this.state.currentHotel) {
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
        }

        this.setState({query: query});
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('Payroll', {
            where: query,
            include: 'hotel,createdBy', 
            skip: 0, 
            limit: this.state.limit, 
            count: 1, 
            order: 'requestedAt'
        }).then(resp => {

            //this.getPreviousTotal();
            this.props.dispatch({type: 'app/hideLoadingTable'})
            this.setState({ skip: this.state.limit, total_items: resp.count });

            /*if (resp.results.length > 0)
                this.groupByDate(resp.results, resp.count)
            else
                this.props.dispatch({type: 'app/hideLoadingTable'})*/


            if (resp.results.length > 0) {
                _.map(resp.results, (item) => {

                    _.map(item.employees, (employeItem) => {
                        employeItem.id = employeItem.objectId;
                        employeItem.objectId = createPassword();
                    });

                    item.isParent =  true;
                    item.children = item.employees;
                });

                let total = getTotal(resp.results, 'total')
                let total_honorarios = getTotal(resp.results, 'total_honorarios')
                let total_relative = getTotal(resp.results, 'total_relative')
                let subtotal = total + total_honorarios + total_relative

                this.setState({
                    currentTotal: subtotal + (subtotal * 0.16), 
                    incomes: resp.results
                });

                this.props.dispatch({type:'income/querySuccess', 
                    payload: { incomes: this.state.incomes }
                });
            } else {
                this.setState({ currentTotal: 0 });                
            }

        }).catch(e => {
            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error al consultar los registros. Intente más tarde')    
        });
    }


    /**
    * Carga otro bloque de registros
    */
    loadMore () {
        if (this.props.income.skip < this.props.income.total_items) {

            this.props.dispatch({type: 'app/showLoadingTable'})

            all('Payroll', {
                where: this.state.query,
                include: 'hotel,createdBy', 
                skip: this.props.income.skip, 
                limit: this.props.income.limit, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {

                this.props.dispatch({type: 'app/hideLoadingTable'})
                this.props.dispatch({type:'income/filterSuccess', 
                    payload: { incomes: [] }
                });

                /*if (resp.results.length > 0)
                    this.groupByDate(resp.results, resp.count)
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})*/

                if (resp.results.length > 0) {
                    _.map(resp.results, (item) => {

                        _.map(item.employees, (employeItem) => {
                            employeItem.id = employeItem.objectId;
                            employeItem.objectId = createPassword();
                        });

                        item.isParent =  true;
                        item.children = item.employees;
                    });

                    let array = this.state.incomes;
                    
                    let total = getTotal(resp.results, 'total')
                    this.setState({ currentTotal: total, incomes: array.concat(resp.results) });

                    this.props.dispatch({type:'income/querySuccess', 
                        payload: { incomes: this.state.incomes }
                    });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error al consultar otros registros. Intente más tarde')    
            });
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Búsqueda
    */
    search (e) {
        this.props.dispatch({type: 'app/showLoadingTable'})

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Query
            let query = {chargedTo: this.props.params.incomeType};

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            if (values.hotel && values.hotel.key) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
            }

            if (values.custom_date) {
                _.extend(query, {
                    $or: [
                        {
                            startAt: {
                                $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).startOf('month').format()).toISOString()},
                                $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).endOf('month').format()).toISOString()},
                            }
                        },
                        {
                            endAt: {
                                $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).startOf('month').format()).toISOString()},
                                $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).endOf('month').format()).toISOString()},
                            }
                        }
                    ]
                });

            } else {
                query.startAt = {
                    $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
                    $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
                };
            }


            this.setState({query: query});

            all('Payroll', {
                where: query,
                include: 'hotel,createdBy', 
                skip: 0, 
                limit: this.state.limit, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {

                this.props.dispatch({type: 'app/hideLoadingTable'})
                this.setState({incomes: [], skip: this.state.limit, total_items: resp.count});

                //this.getPreviousTotal();
                this.props.dispatch({type:'income/filterSuccess', 
                    payload: {
                        incomes: [], 
                        skip: this.state.limit, 
                        total_items: resp.count
                    }
                });

                /*if (resp.results.length > 0)
                    this.groupByDate(resp.results, resp.count);
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})*/

                if (resp.results.length > 0) {
                    _.map(resp.results, (item) => {

                        _.map(item.employees, (employeItem) => {
                            employeItem.id = employeItem.objectId;
                            employeItem.objectId = createPassword();
                        });

                        item.isParent =  true;
                        item.children = item.employees;
                    });

                    let total = getTotal(resp.results, 'total')
                    let total_honorarios = getTotal(resp.results, 'total_honorarios')
                    let total_relative = getTotal(resp.results, 'total_relative')
                    let subtotal = total + total_honorarios + total_relative

                    this.setState({
                        currentTotal: subtotal + (subtotal * 0.16), 
                        incomes: resp.results
                    });

                    this.props.dispatch({type:'income/querySuccess', 
                        payload: { incomes: this.state.incomes }
                    });
                } else {
                    this.setState({ currentTotal: 0 });                
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        })
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
        let dispatch = this.props.dispatch;
        let currentTotal = this.state.currentTotal;
        let currentState = this;

        confirm({
            title: '¿Estás seguro que deseas eliminar el registro?',
            onOk () {
                let total = item.total;
                let total_honorarios = item.total_honorarios;
                let total_relative = item.total_relative;
                let subtotal = total + total_honorarios + total_relative

                currentState.setState({ currentTotal: currentTotal - (subtotal + (subtotal * 0.16)) });
                dispatch({type: 'income/removeItem', payload: item});
            }
        })
    }


    /**
    * Establece el acción para editar
    */
    setUpdate (item) {
        this.setState({ newIncomeProps: {incomeId: item.objectId} });
        this.showModalNewIncome();
    }


    /**
    * Establece el acción para crear
    */
    setCreate (item) {
        this.setState({ newIncomeProps: {incomeType: this.props.params.incomeType} });
        this.showModalNewIncome();
    }


    /**
    * Imprime la nómina
    */
    printPayroll () {
        var headstr = "<html><head><title></title></head><body>";
        var footstr = "</body>";
        var newstr = document.all.item('main-print').innerHTML;
        var oldstr = document.body.innerHTML;
        document.body.innerHTML = headstr+newstr+footstr;
        window.print();

        this.props.dispatch({type: 'app/showLoading'})
        document.body.innerHTML = oldstr;
        window.location.reload();
    }


    /**
    * Muestra / Oculta el modal para nuevo ingreso
    */
    showModalNewIncome () { this.setState({ NewIncomeVisible: true }); }
    hideModalNewIncome () { 
        this.props.form.resetFields();
        this.setState({ NewIncomeVisible: false, incomes: [] }); 
        this.props.dispatch({type:'income/filterSuccess', 
            payload: {
                incomes: [], 
                skip: this.state.limit, 
                total_items: 0
            }
        });
        this.search(); 
    }


    /**
    * Muestra el modal de los detalles de la nómina
    */
    showPayrollDetails (id) {
        this.props.dispatch({type: 'app/showLoadingTable'})

        get('Payroll', id, {include: 'createdBy'}).then((resp) => {
            console.log(resp);
            if (resp.employees.length > 0) {
                resp.employees.push({
                    total: getTotal(resp.employees, 'total'),
                    total_neto: getTotal(resp.employees, 'total_neto'),
                });
            }

            this.setState({ currentPayroll: resp });
            this.props.dispatch({type: 'app/hideLoading'})
            this.setState({ showModalPayrollDetails: true });

        }).catch(e => {
            this.props.dispatch({type: 'app/hideLoading'})
            message.error('Ha ocurrido un error al consultar la información. Intente más tarde')    
        });
    }

    hideModalPayrollDetails () { this.setState({ showModalPayrollDetails: false }); }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link onClick={() => window.history.back() }><i className="fa fa-arrow-circle-left"></i></Link>
                        Nóminas&nbsp;
                        <Button type='primary' className="pull-right">
                            <Link onClick={this.setCreate.bind(this)} className=""><Icon name="plus" /> Generar nómina</Link>
                        </Button>
                    </h1>
                </section>

                <section className="content">

                    <Collapse defaultActiveKey={['1']} className="marginBottom20">
                        <Panel header="Filtros" key="1">
                            <Form onSubmit={this.search.bind(this)}>
                                <div className="row">
                                    {/*!this.state.currentHotel 
                                        ? <div className="col-md-3">
                                            <FormItem label="Hotel" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    */}

                                    {/*<div className="col-md-3">
                                        <FormItem label="Empleado" hasFeedback>
                                            {this.props.form.getFieldDecorator('employee')(
                                                <Input size='large' placeholder="Nombre completo" />
                                            )}
                                        </FormItem>
                                    </div>*/}

                                    <div className="col-md-3">
                                        <FormItem label="Mes" hasFeedback>
                                            {this.props.form.getFieldDecorator('custom_date', {
                                                initialValue: moment(new Date, 'YYYY-MM')
                                            })(
                                                <MonthPicker placeholder="Seleccione el mes" />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3" style={{marginTop: 40}}>
                                        <Button type='primary' onClick={() => this.search()} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                            <Icon name="filter" /> Consultar
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        </Panel>
                    </Collapse>

                    <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                        <div className="box-header with-border">
                            <span className="badge bg-green">Nómina del mes</span> <h3><Currency quantity={this.state.currentTotal ? this.state.currentTotal : 0} currency="USD" /></h3>
                        </div>

                        <div className="box-body">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="table-responsive table">

                                        <InfiniteScroll
                                            padding={50}
                                            throttle={100}
                                            onScroll={() => this.loadMore()}>

                                            <Table 
                                                dataSource={this.props.income.incomes} 
                                                rowKey="objectId" 
                                                size="middle" 
                                                loading={this.props.app.loadingTable} 
                                                pagination={false}>

                                                <Column title="Periodo laborado" key="startAt" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Periodo laborado">
                                                            {item.isParent
                                                                ? <span>
                                                                    {item.requestedAt ? moment(item.requestedAt.iso).format('DD/MM/YYYY') : ''}<br />
                                                                    <small>{item.startAt && item.endAt ? moment(item.startAt.iso).format('DD/MM/YYYY') + ' - ' + moment(item.endAt.iso).format('DD/MM/YYYY') : ''}</small><br />
                                                                    <small>{item.periodicity}</small>
                                                                </span>
                                                                : <span>{item.name}</span>
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )} />
                                                <Column title="S. Dia." key="salary" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="S. Dia.">
                                                            {!item.isParent
                                                                ? <Currency quantity={item.salary ? item.salary : 0} currency="USD" />
                                                                : ''
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="D. Trab." key="days" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="D. Trab.">
                                                            {!item.isParent
                                                                ? <span>{item.days ? item.days : 0}</span>
                                                                : ''
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Sueldo" key="total_salary" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Sueldo">
                                                            {!item.isParent
                                                                ? <Currency quantity={item.days * item.salary} currency="USD" />
                                                                : ''
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Prima Dom." key="total_bonus_salary" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Prima Dom.">
                                                            {!item.isParent
                                                                ? <Currency quantity={item.total_bonus_sunday ? item.total_bonus_sunday : 0} currency="USD" />
                                                                : ''
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Total Deducciones" key="total_deductions" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Total Deducciones">
                                                            <Currency quantity={item.total_deductions ? item.total_deductions : 0} currency="USD" /><br />
                                                            <small>ISR: <Currency quantity={item.total_isr ? item.total_isr : 0} currency="USD" /></small><br />
                                                            <small>IMSS: <Currency quantity={item.total_imss ? item.total_imss : 0} currency="USD" /></small>
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Base" key="total_pagadora" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Base">
                                                            {item.total_pagadora ?
                                                                <span>{item.payment_type === 'hotel'
                                                                    ? <span>
                                                                        <Currency quantity={item.total_pagadora} currency="USD" /><br />
                                                                        {!item.isParent ? <small>Hotel</small> : ''}
                                                                    </span>
                                                                    : <span>
                                                                        <Currency quantity={item.total_pagadora} currency="USD" /><br />
                                                                        {!item.isParent ? <small>{item.payment_type === 'pagadora' ? 'Workania' : 'Alta'}</small> : ''}
                                                                    </span>
                                                                }</span>
                                                                : ''
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Restante" key="total_missing" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Restante">
                                                            <Currency quantity={item.total_missing ? item.total_missing : 0} currency="USD" /><br />
                                                            {!item.isParent
                                                                ? <small>
                                                                    {item.payment_type === 'pagadora' && this.props.params.incomeType === 'trie' ? 'TRIE' : ''}
                                                                    {item.payment_type === 'pagadora' && this.props.params.incomeType === 'hotel' && !item.chargedTo ? 'Hotel' : ''}
                                                                    {item.payment_type === 'trie' ? 'Depósito' : ''}
                                                                    {item.payment_type !== 'trie' && item.chargedTo ? item.chargedTo : ''}
                                                                </small>
                                                                : ''
                                                            }
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Total" key="total" render={(item) => (
                                                    <span className="color-red">
                                                        <Tooltip placement="right" title="Total">
                                                            <Currency quantity={item.total ? item.total : 0} currency="USD" />
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Infonavit" key="total_infonavit" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Infonavit">
                                                            <Currency quantity={item.total_infonavit ? item.total_infonavit : 0} currency="USD" />
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Total Neto" key="total_neto" render={(item) => (
                                                    <span>
                                                        <Tooltip placement="right" title="Total Neto">
                                                            <Currency quantity={item.total_neto ? item.total_neto : 0} currency="USD" />
                                                        </Tooltip>
                                                    </span>
                                                )}/>
                                                <Column title="Honorarios" key="total_honorarios" render={(item) => (
                                                    <Tooltip placement="right" title="Honorarios">
                                                        <Currency quantity={item.total_honorarios ? item.total_honorarios : 0} currency="USD" />
                                                    </Tooltip>
                                                )}/>
                                                <Column title="Relativos" key="total_relative" render={(item) => (
                                                    <Tooltip placement="right" title="Relativos">
                                                        <Currency quantity={item.total_relative ? item.total_relative : 0} currency="USD" />
                                                    </Tooltip>
                                                )}/>                                                
                                                <Column title="Acciones" key="action" width={90}
                                                    render={(item) => (
                                                        <span className="actions">
                                                            {item.isParent
                                                                ? <ButtonGroup>
                                                                    {/*<Tooltip placement="bottom" title="Editar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                                        </Button>
                                                                    </Tooltip>*/}

                                                                    <Tooltip placement="bottom" title="Imprimir">
                                                                        <Button>
                                                                            <Link onClick={() => { this.showPayrollDetails(item.objectId) }}><Icon name="print" /></Link>
                                                                        </Button>
                                                                    </Tooltip>

                                                                    <Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                </ButtonGroup>
                                                                : ''
                                                            }
                                                        </span>
                                                    )}
                                                />
                                            </Table>        
                                        </InfiniteScroll>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Modal
                    visible={this.state.NewIncomeVisible}
                    title="Pago de nómina"
                    width={1200}
                    onCancel={this.hideModalNewIncome.bind(this)}
                    footer={[]} 
                    style={{top: 10}}
                >
                    {this.state.NewIncomeVisible
                        ? <PayrollNew {...this.state.newIncomeProps} />
                        : ''
                    }
                </Modal>

                <Modal
                    visible={this.state.showModalPayrollDetails}
                    title="Imprimir"
                    width={1000}
                    onCancel={this.hideModalPayrollDetails.bind(this)}
                    footer={[
                        <Button key="print" type="primary" onClick={() => { this.printPayroll() }}>
                            <Icon name="print" /> Imprimir
                        </Button>
                    ]} 
                >
                    {this.state.currentPayroll
                        ? <div id="main-print">
                            <Card title="Nónima" className="marginBottom20">
                                <div className="row">
                                    <div className="col-md-12">
                                        <strong>Periodo laborado: </strong>
                                        {this.state.currentPayroll.startAt && this.state.currentPayroll.endAt ? moment(this.state.currentPayroll.startAt.iso).format('DD/MM/YYYY') + ' - ' + moment(this.state.currentPayroll.endAt.iso).format('DD/MM/YYYY') : ''}
                                    </div>

                                    <div className="col-md-12">
                                        <strong>Observaciones: </strong><br />
                                        {this.state.currentPayroll.notes}
                                    </div>
                                </div>
                            </Card>

                            {this.state.currentPayroll.employees.length > 0
                                ? <div className="row">
                                    <div className="col-md-12">
                                        <Table 
                                            dataSource={this.state.currentPayroll.employees} 
                                            rowKey="objectId" 
                                            size="small" 
                                            pagination={false}>

                                            <Column title="Nombre" key="name" render={(item) => (
                                                <span>{item.name}</span>
                                            )}/>

                                            <Column title="S. Diario" key="salary" render={(item) => (
                                                <span>{item.salary ? <Currency quantity={item.salary} currency="USD" /> : ''}</span>
                                            )}/>

                                            <Column title="D. Trab." key="days" render={(item) => (
                                                <span>{item.days}</span>
                                            )}/>

                                            <Column title="ISR" key="total_isr" render={(item) => (
                                                <span>{item.total_isr ? <Currency quantity={item.total_isr} currency="USD" /> : ''}</span>
                                            )}/>

                                            <Column title="IMSS" key="total_imss" render={(item) => (
                                                <span>{item.total_imss ? <Currency quantity={item.total_imss} currency="USD" /> : ''}</span>
                                            )}/>

                                            <Column title="Total Deducciones" key="total_deductions" render={(item) => (
                                                <span>{item.total_deductions ? <Currency quantity={item.total_deductions} currency="USD" /> : ''}</span>
                                            )}/>

                                            <Column title="Base" key="total_pagadora" render={(item) => (
                                                <span>
                                                    {item.total_pagadora ?
                                                        <span>{item.payment_type === 'hotel'
                                                            ? <span>
                                                                <Currency quantity={item.total_pagadora} currency="USD" /><br />
                                                                <small>Hotel</small>
                                                            </span>
                                                            : <span>
                                                                <Currency quantity={item.total_pagadora} currency="USD" /><br />
                                                                <small>{item.payment_type === 'pagadora' ? 'Workania' : 'Alta'}</small>
                                                            </span>
                                                        }</span>
                                                        : ''
                                                    }
                                                </span>
                                            )}/>

                                            <Column title="Restante" key="total_missing" render={(item) => (
                                                <span>
                                                    {item.total_missing && item.payment_type !== 'hotel'
                                                        ? <span>
                                                            <Currency quantity={item.total_missing} currency="USD" /><br />
                                                            <small>
                                                                {item.payment_type === 'pagadora' && this.props.params.incomeType === 'trie' ? 'TRIE' : ''}
                                                                {item.payment_type === 'pagadora' && this.props.params.incomeType === 'hotel' && !item.chargedTo ? 'Hotel' : ''}
                                                                {item.payment_type === 'trie' ? 'Depósito' : ''}
                                                                {item.payment_type !== 'trie' && item.chargedTo ? item.chargedTo : ''}
                                                            </small>
                                                        </span>
                                                        : null
                                                    }
                                                </span>
                                            )}/>

                                            <Column title="Total" key="total" render={(item) => (
                                                <Currency quantity={item.total ? item.total : 0} currency="USD" />
                                            )}/>

                                            <Column title="Infonavit" key="total_infonavit" render={(item) => (
                                                <span>{item.total_infonavit ? <Currency quantity={item.total_infonavit} currency="USD" /> : ''}</span>
                                            )}/>

                                            <Column title="Total Neto" key="total_neto" render={(item) => (
                                                <Currency quantity={item.total_neto ? item.total_neto : 0} currency="USD" />
                                            )}/>
                                        </Table>  
                                    </div>
                                </div>
                                : ''
                            }
                        </div>
                        : ''
                    }
                </Modal>
            </div>
        )
    }
}

export default connect(({income, app}) => ({income, app}))(Form.create()(Payroll))


// WEBPACK FOOTER //
// ./src/components/incomes/payroll.js